import {refreshWidgets} from 'common/src/modules/campaigns/store/insightsPage/features';
import dashboardsApi from 'common/src/modules/dashboards/dashboards.api';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import toolError from 'common/src/modules/shared/copilot/utils/toolError';
import {CLStore} from 'common/src/redux/store';
import {z} from 'zod';
import {CampaignAnalyticsToolName} from '../campaignAnalyticsAgent.enums';

function deleteWidgetTool(store: CLStore) {
  const inputSchema = z.object({
    dashboardId: z.number().describe('ID of dashboard to delete widget from'),
    widgetId: z.number().describe('ID of widget to delete'),
  });

  async function execute({
    input: {widgetId, dashboardId},
  }: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    try {
      await dashboardsApi.deleteWidget(widgetId);

      store.dispatch(refreshWidgets({dashboardId}));

      return toolResult('Widget deleted successfully');
    } catch (error) {
      return toolError('An error occurred while deleting the widget');
    }
  }

  return tool({
    name: CampaignAnalyticsToolName.DeleteWidget,
    displayName: 'Deleting Widget',
    description: 'Delete a dashboard widget',
    execute,
    inputSchema,
  });
}

export default deleteWidgetTool;
